import React from "react"
import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { combineProviders } from "@/utilities"
import { App as AntDApp, ConfigProvider } from "antd"
import colors from "@/styles/colors"
import { SyncNotificationProvider } from "@/core/contexts"
import { theme } from "twin.macro"

const queryClient = new QueryClient({
    defaultOptions: {
        queries: { refetchOnWindowFocus: false, retry: false }
    }
})

const MasterProvider = combineProviders({
    drilling: false,
    providers: [
        // <React.StrictMode key="react-strict-mode" />,
        <QueryClientProvider key="query-client" client={queryClient} />,
        <ConfigProvider
            key="antd-theme"
            theme={{
                token: {
                    // Seed Token
                    fontFamily: "Inter, -apple-system, BlinkMacSystemFont, sans-serif",
                    colorPrimary: colors.primary,
                    colorPrimaryHover: colors.primary_hover,
                    colorTextBase: colors.text_body,
                    colorError: colors.red600,
                    colorErrorHover: colors.red700,
                    colorText: colors.text_body,
                    colorBgTextActive: colors.gray300,
                    borderRadius: 4,
                    // MapToken
                    // ...
                    // AliasToken
                    colorTextPlaceholder: colors.text_disable,
                    colorIcon: colors.gray500,
                    colorIconHover: colors.gray600
                },
                // ComponentToken
                components: {
                    Button: {
                        textHoverBg: colors.gray200,
                        defaultHoverBg: colors.gray200,
                        defaultBorderColor: colors.gray300,
                        defaultHoverBorderColor: colors.gray300,
                        defaultActiveBorderColor: colors.gray300,
                        defaultActiveBg: colors.gray300
                    },
                    Select: { optionSelectedBg: theme`colors.white` },
                    Tabs: {
                        cardPadding: "16px 16px",
                        horizontalMargin: "0"
                    }
                }
            }}
        />,
        <AntDApp key="Ant Design App" />,
        <SyncNotificationProvider key="sync-notification" />
    ]
})

export default MasterProvider
